require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-will-strong-analysis-in-the-world-banks-vietnam-country.json") })
        }
      }, "path---en-us-update-will-strong-analysis-in-the-world-banks-vietnam-country");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-will-strong-analysis-in-the-world-banks-vietnam-country!./.cache/json/en-us-update-will-strong-analysis-in-the-world-banks-vietnam-country.json
// module id = 870
// module chunks = 231608221292675